module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_10.7d26328f.jpg";